import { Component } from '@angular/core';
import { ReportShareComponent } from '../../report-share.component';

@Component({
  selector: 'app-coachee-style-combinations',
  templateUrl: './coachee-style-combinations.component.html'
})
export class CoacheeStyleCombinationsComponent extends ReportShareComponent {

  get html(): string {
    return this.report?.combinationDescOne?.replaceAll("\n","<br />") ?? '';
  }

}
